<template>
  <error-content code="404" :desc="$t('pages_error_page_404_496')" :src="src" />
</template>

<script>
import i18n from '../../locales/index'

import error404 from '@/assets/images/error-page/error-404.svg'
import errorContent from './error-content.vue'
export default {
  name: 'error_404',
  components: {
    errorContent
  },
  data () {
    return {
      src: error404
    }
  }
}
</script>
